import React, {useState} from "react";
import { Table } from "antd";
import { useSelector } from "react-redux";
import commaNumber from "comma-number";
import _ from "lodash";

const format = commaNumber.bindWith(",", ".");

const ExpenseBalanceTable = () => {
  const { list, loading, balanceTotal } = useSelector((state) => state.expenseBalance);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const columns = [
    { title: "No.", render: (_, __, index) => index + 1, width: 60 },
    { 
      title: "Account Name", 
      dataIndex: "acc_name", 
      width: 200,
    },
    {
      title: "Opening Balance",
      dataIndex: "opening_balance",
      render: (val) => format(parseFloat(val || 0).toFixed(2)),
      align: "right",
      width: 120
    },
    {
      title: "Debit Amount",
      dataIndex: "debit_amount",
      render: (val) => format(parseFloat(val || 0).toFixed(2)),
      align: "right",
      width: 120
    },
    {
      title: "Credit Amount",
      dataIndex: "credit_amount",
      render: (val) => format(parseFloat(val || 0).toFixed(2)),
      align: "right",
      width: 120
    },
    {
      title: "Expense Amount",
      dataIndex: "balance",
      render: (val) => format(parseFloat(val || 0).toFixed(2)),
      align: "right",
      width: 120
    },
  ];

  const totals = list.reduce(
    (acc, row) => {
      acc.opening_balance += Number(row.opening_balance || 0);
      acc.debit_amount += Number(row.debit_amount || 0);
      acc.credit_amount += Number(row.credit_amount || 0);
      return acc;
    },
    { opening_balance: 0, debit_amount: 0, credit_amount: 0 }
  );

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={list}
      loading={loading}
      pagination={{
        ...pagination,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50"],
      }}
      onChange={handleTableChange}
      bordered
      scroll={{ x: 'max-content' }}
      size="middle"
      summary={() => (
        <>
          <Table.Summary.Row>
            <Table.Summary.Cell index={0} colSpan={2}>
              <strong>Grand Total</strong>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={2} align="right">
              <strong>{format(totals.opening_balance.toFixed(2))}</strong>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={3} align="right">
              <strong>{format(totals.debit_amount.toFixed(2))}</strong>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={4} align="right">
              <strong>{format(totals.credit_amount.toFixed(2))}</strong>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={5} align="right">
              <strong>{format(parseFloat(balanceTotal || 0).toFixed(2))}</strong>
            </Table.Summary.Cell>
          </Table.Summary.Row>
        </>
      )}
    />
  );
};

export default ExpenseBalanceTable;